import { DropdownMenu } from '@octopus-do/octopus-storybook'
import type React from 'react'

import { DownloadMenu } from '../../../../../DownloadMenu'

export const FileContent: React.FC = () => (
  <>
    <DropdownMenu.NestedMenu
      id="download"
      title="Download"
      content={DownloadMenu}
    />
  </>
)
